function pythalChromeString(key, fallback) {
  try {
    if (!window.__pythalChromeStrings) {
      const node = document.getElementById('pythal-chrome-strings');
      window.__pythalChromeStrings = node ? JSON.parse(node.textContent) : {};
    }
    const value = window.__pythalChromeStrings[key];
    return typeof value === 'string' && value ? value : fallback;
  } catch (_error) {
    return fallback;
  }
}

(() => {
  'use strict';

  const UAE_HOSTS = new Set(['pythal.ae', 'www.pythal.ae']);
  const INDIA_HOSTS = new Set(['pythal.in', 'www.pythal.in']);
  const hostname = window.location.hostname.toLowerCase();
  const activeCurrency = String(window.Shopify?.currency?.active || '').toUpperCase();
  const marketHint = activeCurrency === 'AED' ? 'uae' : activeCurrency === 'INR' ? 'india' : '';
  const isUaeStore = UAE_HOSTS.has(hostname) || marketHint === 'uae';
  const isIndiaStore = INDIA_HOSTS.has(hostname) || marketHint === 'india';
  const marketHomeLabel = isIndiaStore
    ? pythalChromeString('homeIndia', 'Pythal India home')
    : pythalChromeString('homeUae', 'Pythal UAE home');

  function normalizeMarketUrl(rawHref) {
    if (!isUaeStore || !rawHref || rawHref.startsWith('#') || rawHref.startsWith('mailto:') || rawHref.startsWith('tel:') || rawHref.startsWith('javascript:')) return rawHref;

    let url;
    try { url = new URL(rawHref, window.location.origin); } catch (_error) { return rawHref; }

    if (INDIA_HOSTS.has(url.hostname.toLowerCase())) {
      url.protocol = window.location.protocol;
      url.host = window.location.host;
    }

    // Leave links to other sites (WhatsApp, social profiles) untouched.
    if (url.hostname !== window.location.hostname) return rawHref;

    if (url.pathname === '/apps/box-builder/custom-baby-hamper') url.pathname = '/apps/box-builder/custom-bundle';
    return `${url.pathname}${url.search}${url.hash}`;
  }

  function cleanLabel(value) {
    return value.replace(/\s*\|\s*/g, ' | ').replace(/\s{2,}/g, ' ').trim();
  }

  function navigateFromParentLabel(event) {
    const summary = event.currentTarget;
    const rawUrl = (summary.dataset.pythalParentUrl || '').trim();
    const url = normalizeMarketUrl(rawUrl);
    if (!url || url === '#' || event.detail === 0 || event.target.closest('.icon-arrow, .icon-arrow-right, i')) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.metaKey || event.ctrlKey) window.open(url, '_blank', 'noopener');
    else window.location.assign(url);
  }

  function enhanceParentMenus(root = document) {
    root.querySelectorAll('summary[data-pythal-parent-url]').forEach((summary) => {
      const normalized = normalizeMarketUrl(summary.dataset.pythalParentUrl || '');
      if (normalized) summary.dataset.pythalParentUrl = normalized;
      if (summary.dataset.pythalParentBound === 'true') return;
      summary.dataset.pythalParentBound = 'true';
      summary.addEventListener('click', navigateFromParentLabel);
    });
  }

  function repairUaeLinks(root = document) {
    if (!isUaeStore) return;
    root.querySelectorAll('a[href]').forEach((anchor) => {
      const rawHref = anchor.getAttribute('href');
      const normalized = normalizeMarketUrl(rawHref);
      if (normalized && normalized !== rawHref) anchor.setAttribute('href', normalized);
    });
  }

  function removeDuplicateViewAllRows(root = document) {
    root.querySelectorAll('.shopify-section-header a[href]').forEach((anchor) => {
      const text = anchor.textContent.replace(/\s+/g, ' ').trim();
      if (!/^view\s+all(?:\s|$)/i.test(text)) return;
      const row = anchor.closest('li');
      if (row) { row.dataset.pythalViewAll = 'true'; row.hidden = true; }
      else anchor.hidden = true;
    });
  }

  function normalizeVisibleLabels(root = document) {
    root.querySelectorAll('.shopify-section-header .header__menu-item, .shopify-section-header .menu-drawer__menu-item, .py-home__ready-card strong').forEach((node) => {
      if (node.children.length > 0) return;
      const cleaned = cleanLabel(node.textContent);
      if (cleaned && cleaned !== node.textContent.trim()) node.textContent = cleaned;
    });
  }

  function improveLogoAccessibility(root = document) {
    root.querySelectorAll('.header__heading-link').forEach((link) => {
      if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', marketHomeLabel);
      const image = link.querySelector('img.header__heading-logo');
      const name = link.querySelector('.header__heading-name');
      if (image && name) image.setAttribute('alt', '');
    });
  }

  function init(root = document) {
    enhanceParentMenus(root);
    repairUaeLinks(root);
    removeDuplicateViewAllRows(root);
    normalizeVisibleLabels(root);
    improveLogoAccessibility(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target || document));

  if (isUaeStore) {
    /*
      Do not observe the entire document. Shopify preview, pixels and app extensions inject
      many nodes during startup; the old document-wide observer re-ran five full selector
      scans for every injection and amplified main-thread work. Only header mutations need
      the navigation repairs, and those are batched to one animation frame.
    */
    const headerRoot = document.querySelector('.shopify-section-header') || document.querySelector('sticky-header');
    if (headerRoot && 'MutationObserver' in window) {
      let queued = false;
      const observer = new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          init(headerRoot);
        });
      });
      observer.observe(headerRoot, { childList: true, subtree: true });
    }

    document.addEventListener('click', (event) => {
      const anchor = event.target.closest?.('a[href]');
      if (!anchor) return;
      if (anchor.closest('.shopify-section-header')) {
        const text = anchor.textContent.replace(/\s+/g, ' ').trim();
        if (/^view\s+all(?:\s|$)/i.test(text)) { event.preventDefault(); return; }
      }
      const rawHref = anchor.getAttribute('href');
      const normalized = normalizeMarketUrl(rawHref);
      if (normalized && normalized !== rawHref) anchor.setAttribute('href', normalized);
    }, true);
  }
})();

function pythalLabelUntitledFrames() {
  document.querySelectorAll('iframe:not([title]), iframe[title=""]').forEach((frame) => {
    const source = String(frame.getAttribute('src') || '');
    frame.setAttribute('title', source.includes('shopify') || source.includes('web-pixel') ? pythalChromeString('frameServices', 'Shopify storefront services') : pythalChromeString('frameEmbedded', 'Embedded storefront content'));
  });
}

/* One bounded pass is enough; avoid rescanning at both DOMContentLoaded and load. */
if (document.readyState === 'complete') pythalLabelUntitledFrames();
else window.addEventListener('load', pythalLabelUntitledFrames, { once: true });
